export const SUMMARY_FIELDS_BY_CATEGORY = {
  process: ['agent.uuid', 'src.process.uid', 'osSrc.process.uid', 'tgt.process.uid'],
  cross_process: ['agent.uuid', 'src.process.uid', 'osSrc.process.uid', 'tgt.process.uid', 'tgt.process.relation'],
  command_script: ['agent.uuid', 'src.process.uid', 'osSrc.process.uid', 'cmdScript.content'],
  ip: [
    'agent.uuid',
    'src.process.uid',
    'osSrc.process.uid',
    'src.ip.address',
    'src.port.number',
    'dst.ip.address',
    'dst.port.number',
    'event.network.direction',
    'event.network.connectionStatus',
  ],
  file: ['agent.uuid', 'src.process.uid', 'osSrc.process.uid', 'tgt.file.path'],
  logins: [
    'agent.uuid',
    'src.process.uid',
    'osSrc.process.uid',
    'src.endpoint.ip.address',
    'event.login.userName',
    'event.login.type',
    'event.login.loginIsSuccessful',
  ],
  url: ['agent.uuid', 'src.process.uid', 'osSrc.process.uid', 'url.address', 'event.url.action'],
  dns: ['agent.uuid', 'src.process.uid', 'osSrc.process.uid', 'event.dns.request', 'event.dns.response'],
  scheduled_task: ['agent.uuid', 'src.process.uid', 'osSrc.process.uid', 'task.name'],
  registry: ['agent.uuid', 'src.process.uid', 'osSrc.process.uid', 'registry.keyPath', 'registry.value'],
  indicators: [
    'agent.uuid',
    'src.process.uid',
    'osSrc.process.uid',
    'indicator.name',
    'indicator.category',
    'indicator.description',
  ],
  module: ['agent.uuid', 'src.process.uid', 'osSrc.process.uid', 'module.path'],
  firmware: ['agent.uuid', 'src.process.uid', 'osSrc.process.uid'],
  threat_intelligence_indicators: [
    'agent.uuid',
    'src.process.uid',
    'osSrc.process.uid',
    'tiIndicator.source',
    'tiIndicator.value',
  ],
  named_pipe: ['agent.uuid', 'src.process.uid', 'osSrc.process.uid'],
};
